import { UserProfile } from './UserProfile'

export enum UserGender {
  Female = 'GENDER.FEMALE',
  Male = 'GENDER.MALE',
}

export interface WebsitePromoState {
  stage: 0 | 1 | 2 | 3
  nextShowAt?: string | null
  convertedAt?: string | null
}

export interface User {
  _id: string
  firstname: string
  lastname: string
  email: string
  token: string
  phone?: string
  profiles: UserProfile[]
  promos?: {
    websitePromo?: WebsitePromoState
  }
}
